export default "__VITE_ASSET__UdD0eWDo__"